import React from "react";

import { useLocation } from "react-router-dom";

import { Button, SubHeader } from "clearsense-ui/components";
import { Plus } from "components/Common/clearsense-ui/icons";

const PrimaryHeader = ({
  id,
  name,
  isLoading,
  setIsNewWhatIfPaneOpen,
  datasetName,
}) => {
  const { pathname } = useLocation();

  const currentPath = pathname.substring(pathname.lastIndexOf("/") + 1);

  return (
    <SubHeader
      className="mb-8 capitalize"
      breadcrumbs={[
        {
          label: "Approachable AI",
          link: datasetName
            ? `/consumption/data-science/quality-analysis/${datasetName}/approachable-ai`
            : `/consumption/data-science/quality-analysis/approachable-ai`,
        },
        isLoading
          ? { label: "", link: "" }
          : { label: name || `Analysis ${id}`, link: "#" },
      ]}
      actionBlock={
        currentPath === "what-if" ? (
          <Button
            label={"New What-If Analysis"}
            icon={Plus}
            data-cy="new-whatif-analysis-button"
            onClick={() => setIsNewWhatIfPaneOpen(true)}
          />
        ) : null
      }
    />
  );
};

export default PrimaryHeader;
